export default __webpack_public_path__ + "static/media/dkron-logo.cd9d7840.png";